import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { fetchAccountDetails } from '../../../actions/adminActions';
import { saveRole, activeRole, deleteRole } from '../../../actions/roleActions';

import Users from '../UserList/Users';
import AccountFeatures from './AccountFeatures';

class CreateRole extends Component {
  static propTypes = {
    handleBack: PropTypes.func,
    fetchAccountDetails: PropTypes.func,
    updatedActivePage: PropTypes.func,
    selectedRole: PropTypes.instanceOf(Object),
    accountDetail: PropTypes.instanceOf(Object),
    roleModules: PropTypes.instanceOf(Object),
    roleUsers: PropTypes.instanceOf(Object),
    roleTeams: PropTypes.instanceOf(Object),
  };

  static defaultProps = {
    selectedRole: {},
    accountDetail: {},
    roleModules: [],
    roleUsers: [],
    roleTeams: [],
  };

  state = {
    role: {},
    allUsers: [],
    allTeams: [],
    activeUsers: [],
    activeTeams: [],
    clearUsers: false,
    allFeatures: [],
    activeFeatures: [],
    hasError: false,
    successMessage: '',
    serviceError: '',
  };

  UNSAFE_componentWillMount() {
    this.updateInitialValues();
  }

  onInputChange = (e, type) => {
    const role = _.cloneDeep(this.state.role);
    let value = e.target.value;
    if (value.trim().length === 0) {
      value = '';
    }
    role[type] = value;
    this.setState({ role });
  };

  updateSelectedItems = activeUsers => {
    this.setState({ activeUsers });
  };

  updateInitialValues = () => {
    const { accountDetail, roleUsers, roleTeams, roleModules } = this.props;
    const activeUsers = [];
    const activeTeams = [];
    if (!_.isEmpty(roleUsers)) {
      roleUsers.map(user => {
        activeUsers.push(user);
        return false;
      });
    }
    if (!_.isEmpty(roleTeams)) {
      roleTeams.map(team => {
        activeTeams.push(team);
        return false;
      });
    }

    // The initial active features should not have RLD (14) and ACC (17) permissions
    const activeFeaturesWithoutRldAcc = accountDetail.features.map(feature => ({
      ...feature,
      permissions: feature.permissions.filter(permission => permission.id !== 14 || permission.id !== 17)
    }));

    this.setState({
      activeUsers: this.props.selectedRole.id ? activeUsers : [],
      activeTeams: this.props.selectedRole.id ? activeTeams : [],
      role: this.props.selectedRole,
      allUsers: accountDetail.users,
      allTeams: accountDetail.teams.filter(item => item.activeStatus === 'Y'),
      allFeatures: accountDetail.features,
      activeFeatures: this.props.selectedRole.name
        ? roleModules
        : activeFeaturesWithoutRldAcc,
    });
  };

  handlePermissionChange = allFeatures => {
    const allAccountFeatures = this.state.allFeatures;
    const activeFeatures = [];
    _.map(allFeatures, feature => {
      const hasPermissions = _.map(feature.permissions, item => item.isChecked);
      const currentFeature = _.filter(
        allAccountFeatures,
        item => item.moduleId === feature.moduleId
      );
      if (hasPermissions.includes(true)) {
        const permissions = [];
        _.map(feature.permissions, item => {
          if (item.isChecked) {
            _.map(currentFeature[0].permissions, k => {
              if (item.id === k.id) {
                permissions.push(k);
              }
            });
          }
        });
        if (!_.isEmpty(permissions)) {
          const featureObj = {
            ...feature,
            permissions,
          };
          activeFeatures.push(featureObj);
        }
      }
    });
    this.setState({ activeFeatures });
  };

  handleReset = () => {
    this.setState(
      {
        clearUsers: false,
        hasError: false,
      },
      () => {
        this.updateInitialValues();
      }
    );
  };

  handleSave = () => {
    const {
      activeUsers,
      role,
      activeFeatures,
      allUsers,
      allTeams,
    } = this.state;
    const { accountDetail } = this.props;
    const { name = '', description = '', id = '' } = role;

    const users = [];
    const teams = [];

    _.map(allUsers, user => {
      _.map(activeUsers, item => {
        if (item.type === 'USER' && item.itemId === user.userId) {
          users.push(user);
        }
      });
    });
    _.map(allTeams, team => {
      _.map(activeUsers, item => {
        if (item.type === 'TEAM' && item.itemId === team.id) {
          teams.push(team);
        }
      });
    });
    const request = {
      accountId: accountDetail.accountId,
      name: name.trim(),
      description: description.trim(),
      id,
      users,
      teams,
      modules: activeFeatures,
    };
    let activeStatus = 'N';
    if (this.props.selectedRole.name) {
      activeStatus = this.props.selectedRole.activeStatus;
    } else {
      activeStatus = 'Y';
    }
    if (
      name &&
      description &&
      !_.isEmpty(activeFeatures) &&
      activeStatus === 'Y'
    ) {
      this.setState(
        { hasError: false, serviceError: '', successMessage: '' },
        () => {
          saveRole(request).then(response => {
            if (response.data === 'SUCCESS') {
              this.setState(
                { successMessage: 'Role saved successfully' },
                () => {
                  if (this.state.successMessage) {
                    setTimeout(() => {
                      this.props.fetchAccountDetails(accountDetail);
                      this.props.updatedActivePage({ activeRolePage: 'ROLES' });
                    }, 2000);
                  }
                }
              );
            }
            if (response.error) {
              this.setState({ serviceError: response.error, hasError: true });
            }
          });
        }
      );
    } else if (activeStatus === 'N') {
      this.setState({
        serviceError: 'Please activate the role.',
        hasError: true,
      });
    } else {
      this.setState({ hasError: true });
    }
  };

  handleDeleteRole = () => {
    const { accountDetail } = this.props;
    const roleId = this.state.role.id;
    this.setState(
      { hasError: false, serviceError: '', successMessage: '' },
      () => {
        deleteRole(roleId).then(response => {
          if (response.data === 'SUCCESS') {
            this.setState(
              { successMessage: 'Role deleted successfully' },
              () => {
                if (this.state.successMessage) {
                  setTimeout(() => {
                    this.props.fetchAccountDetails(accountDetail);
                    this.props.updatedActivePage({ activeRolePage: 'ROLES' });
                  }, 2000);
                }
              }
            );
          }
          if (response.error) {
            this.setState({ serviceError: response.error, hasError: true });
          }
        });
      }
    );
  };

  handleActivateRole = () => {
    const { accountDetail } = this.props;
    const roleId = this.state.role.id;
    this.setState(
      { hasError: false, serviceError: '', successMessage: '' },
      () => {
        activeRole(roleId).then(response => {
          if (response.data === 'SUCCESS') {
            this.setState(
              { successMessage: 'Role activated successfully' },
              () => {
                if (this.state.successMessage) {
                  setTimeout(() => {
                    this.props.fetchAccountDetails(accountDetail);
                    this.props.updatedActivePage({ activeRolePage: 'ROLES' });
                  }, 2000);
                }
              }
            );
          }
          if (response.error) {
            this.setState({ serviceError: response.error, hasError: true });
          }
        });
      }
    );
  };

  render() {
    const {
      role,
      allUsers,
      allTeams,
      activeUsers,
      activeTeams,
      allFeatures,
      activeFeatures,
      hasError,
      successMessage,
      serviceError,
    } = this.state;
    const { name = '', description = '', activeStatus = 'N' } = role;
    const { roleModules, roleUsers, roleTeams } = this.props;

    const { selectedRole } = this.props;
    const addedNewPermissions = !_.isEqual(activeFeatures, roleModules);
    const selectdRoleUserObj = [];
    _.map(activeUsers, user => {
      _.map(allUsers, item => {
        if (user.userId === item.userId && user.firstName === item.firstName) {
          selectdRoleUserObj.push(user);
        }
      });
    });
    const selectdRoleTeamObj = [];
    _.map(activeUsers, team => {
      _.map(allTeams, item => {
        if (team.itemId === item.id && team.name === item.name) {
          selectdRoleTeamObj.push(team);
        }
      });
    });

    const sortedUsers = _.isEmpty(selectdRoleUserObj)
      ? []
      : _.sortBy(selectdRoleUserObj, o => o.firstName);
    const sortedTeams = _.isEmpty(selectdRoleTeamObj)
      ? []
      : _.sortBy(selectdRoleTeamObj, o => o.id);
    const addedNewUsers = !_.isEqual(sortedUsers, roleUsers);
    const addedNewTeams = !_.isEqual(sortedTeams, roleTeams);
    const hasNameUpdate = selectedRole.name !== name;
    const hasDescriptionUpdate = selectedRole.description !== description;

    const hasUpdated =
      addedNewPermissions ||
      addedNewUsers ||
      addedNewTeams ||
      hasNameUpdate ||
      hasDescriptionUpdate;

    let errorMessage = '';

    if (hasError && _.isEmpty(activeFeatures)) {
      errorMessage = 'Atleast one permission should assign to the role.';
    }
    if (hasError && !description) {
      errorMessage = 'Role Description is required field.';
    }

    if (hasError && !name) {
      errorMessage = 'Role name is required field';
    }

    if (serviceError) {
      errorMessage = serviceError;
    }

    let isDisabled = true;
    if (!_.isEmpty(allFeatures)) {
      if (hasUpdated && this.props.hasAccess) {
        isDisabled = false;
      }
    }

    let renderActionButton = '';
    if (this.props.selectedRole.id) {
      if (activeStatus === 'Y') {
        renderActionButton = (
          <button
            onClick={this.handleDeleteRole}
            className="btn deleteButton"
            type="button"
            disabled={!this.props.hasAccess}
          >
            <span>Delete</span>
          </button>
        );
      } else {
        renderActionButton = (
          <button
            onClick={this.handleActivateRole}
            type="button"
            className="btn activateButton"
          >
            <span>Activate</span>
          </button>
        );
      }
    }
    return (
      <div className="accounts-role">
        {errorMessage && <span className="error-message">{errorMessage}</span>}
        {successMessage && (
          <span className="success-message">{successMessage}</span>
        )}
        <div className="accounts-details-card-header">
          <div className="role-title">
            <h4>
              {this.props.selectedRole.name ? 'View/Edit Role' : 'Create Role'}
            </h4>
          </div>
          <div className="adduser-card-actions roles-actions">
            <button
              onClick={this.handleSave}
              className="btn saveButton"
              disabled={isDisabled}
              type="button"
            >
              <span>Save &amp; Apply</span>
            </button>
            <button
              className="btn resetButton"
              disabled={isDisabled}
              onClick={this.handleReset}
              type="button"
            >
              Reset
            </button>
            <button
              onClick={this.props.handleBack}
              className="btn cancelButton"
              type="button"
            >
              <span>Cancel</span>
            </button>
            {renderActionButton}
          </div>
        </div>
        <div className="accounts-role--details custom-account-block">
          <div className="accounts-role--header">
            <div className="accounts-role-input-col">
              <div className="accounts-role--label">Name: </div>
              <div className="accounts-role--name">
                <input
                  className={`form-control ${
                    hasError && !name ? 'has-error' : ' '
                  }`}
                  type="text"
                  value={name}
                  onChange={e => this.onInputChange(e, 'name')}
                  placeholder="Enter role name..."
                />
              </div>
            </div>
            <div className="accounts-role-input-col">
              <div className="accounts-role--label">Description: </div>
              <div className="accounts-role--name">
                <input
                  className={`form-control ${
                    hasError && !description ? 'has-error' : ' '
                  }`}
                  type="text"
                  value={description}
                  onChange={e => this.onInputChange(e, 'description')}
                  placeholder="Enter role description..."
                />
              </div>
            </div>
          </div>
          <AccountFeatures
            allFeatures={allFeatures}
            activeFeatures={activeFeatures}
            handlePermissionChange={this.handlePermissionChange}
            roleName={name}
          />
          <div className="accounts-role-users--wrapper">
            <div className="accounts-role-users">
              <h4>Select User(s)</h4>
              <Users
                users={allUsers}
                activeUsers={activeUsers}
                activeTeams={activeTeams}
                teams={allTeams}
                updateSelectedItems={this.updateSelectedItems}
                clearUsers={this.state.clearUsers}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchAccountDetails: bindActionCreators(fetchAccountDetails, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(CreateRole);
